// Presentation Mode toggle — injected into the storefront navbar for
// Branch / Head Office logged-in users. Flips the site into showing the
// customer-facing RETAIL price instead of the trade price (and hides the
// "Retail: R…" comparison line), so a branch user can present the site to a
// walk-in customer without logging out. See shared/presentation.js for the swap
// engine; the React parts-finder page mirrors this via its own store.
import { loadFeatures } from '../shared/identity.js';
import { onReady } from '../shared/dom.js';
import {
  isPresentationMode, setPresentationMode, initPresentation, PRESENTATION_EVENT,
} from '../shared/presentation.js';

export var id = 'presentation-mode';

// Roles that get the Presentation Mode toggle. Branch + Head Office only —
// (Public / B2C / plain B2B do not). roleKey comes from OE Commerce
// FrontendUserRole.Key, where Branch and HeadOffice are distinct from B2B.
var ALLOWED = { branch: true, headoffice: true, ho: true };

function roleAllowed() {
  var rk;
  try { rk = window.__PARTS_FINDER_FEATURES_ROLE_KEY__; } catch (e) { rk = null; }
  if (!rk) return false;
  var norm = String(rk).toLowerCase().replace(/[\s_-]/g, '');
  return ALLOWED[norm] === true;
}

function reflect(li) {
  var on = isPresentationMode();
  if (on) li.classList.add('pf-on'); else li.classList.remove('pf-on');
  var sw = li.querySelector('.pf-pm-switch');
  if (sw) sw.setAttribute('aria-checked', on ? 'true' : 'false');
}

function buildToggle() {
  var li = document.createElement('li');
  li.id = 'pf-presentation-toggle';
  li.className = 'pf-presentation-toggle';

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'pf-pm-btn';
  btn.setAttribute('title', 'Show retail pricing to present to a customer');

  var label = document.createElement('span');
  label.className = 'pf-pm-label';
  label.textContent = 'Presentation Mode';

  var sw = document.createElement('span');
  sw.className = 'pf-pm-switch';
  sw.setAttribute('role', 'switch');

  btn.appendChild(label);
  btn.appendChild(sw);
  li.appendChild(btn);

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    setPresentationMode(!isPresentationMode());
    reflect(li);
  });

  // Keep the switch in sync if flipped elsewhere (other tab / React page).
  try {
    window.addEventListener(PRESENTATION_EVENT, function () { reflect(li); });
  } catch (e) { /* ignore */ }

  reflect(li);
  return li;
}

// The storefront nav is server-rendered, but be defensive about timing — retry
// briefly if #navbar isn't in the DOM yet.
function whenNav(cb, tries) {
  tries = tries || 0;
  var nav = document.querySelector('#navbar .nav.navbar-nav') || document.querySelector('#navbar .navbar-nav');
  if (nav) { cb(nav); return; }
  if (tries > 40) return; // ~10s
  setTimeout(function () { whenNav(cb, tries + 1); }, 250);
}

export function init() {
  loadFeatures().then(function () {
    if (!roleAllowed()) {
      // Not an eligible role: make sure no stale flag leaves prices swapped.
      try {
        if (isPresentationMode()) setPresentationMode(false);
      } catch (e) { /* ignore */ }
      return;
    }
    initPresentation(); // apply persisted state + start the swap observer
    onReady(function () {
      whenNav(function (nav) {
        if (document.getElementById('pf-presentation-toggle')) return; // idempotent
        nav.appendChild(buildToggle());
      });
    });
  }).catch(function () { /* fail closed: no toggle */ });
}
